<template>
  <div class="design-quality">
    <div class="w">
      <div class="design-quality-content">
        <div class="height-context" v-for="(item, index) of list" :key="index">
          <div class="contents">
            <div class="content-text" @click="edit(item)">
              <img :src="getImageURL(item.mainImg)" alt="" />
              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.subTitle }}</div>
              <div class="edit-content">了解更多</div>
            </div>
          </div>
        </div>
      </div>
      <div class="axiba"></div>
    </div>
  </div>
</template>

<script>
import { baseURL } from '../utils/index.js';
// import url from "../assets/img/dulles/测试下拉产品.jpg";
export default {
  name: "DesignQuality",
  components: {},
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.search()
  },
  watch: {},
  methods: {
     getImageURL(image) {
      return baseURL + image;
    },
    // 查询
    search(){
      this.list = []
      const data = {
        moduleType:2,
        deleteFlag:2,
        usingFlag:1
      }
       this.$http.post(`resource/list`,data).then((res) => {
        this.list = res.data.data
      });
    },
    // 查看详情
    edit(e){
      this.$router.push({ name: "DesignQualityDetails", query: { id: e.id } });
    }
  },
};
</script>

<style lang="scss" scoped>
.design-quality {
  min-height: 88vh;
  background: #f2f2f2;
  .design-quality-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(384px, 0fr));
    column-gap: 44px;
    .height-context {
      padding-top: 40px;
      .contents {
        .content-text {
          width: 350px;
          padding: 16px 16px 38px;
          background: #ffffff;
          border-radius: 12px;
          border: 1px solid #ffffff;
          img {
            width: 100%;
            min-height: 350px;
            border-radius: 12px;
          }
          .title {
            font-size: 26px;
            font-weight: bold;
            margin: 24px 0 10px;
            text-align: center;
          }
          .text {
            font-size: 14px;
            text-align: center;
            width: 238px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 0 auto;
            min-height: 38px;
          }
          .edit-content {
            width: 104px;
            height: 40px;
            margin: 24px auto 0;
            background: #907159;
            border-radius: 19px;
            color: #ffffff;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
          }
        }
        .content-text:hover {
          border: 1px solid #907159;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
  .axiba {
    padding-bottom: 40px;
  }
}
</style>